import { BsGraphUpArrow } from "react-icons/bs";
import { FaBuilding, FaUsers } from "react-icons/fa";
import task_overview from '../../../Assets/DashboardImages/task_overview.png';
import total_engineers from '../../../Assets/DashboardImages/total_engineers.png';
import total_sites from '../../../Assets/DashboardImages/total_sites.png';
import DashboardCard from "../DashnoardComponents/DashboardCard/DashboardCard";
import { dashboardContext } from "../Dashboard";
import useScreenSize from "../../../utils/useScreenSize";
import { useContext } from "react";
import TextSkeleton from "../../../Components/Skeletons/TextSkeleton";
import CustomSkelton from "../../../Components/Skeletons/CustomSkelton";
import DashboardStatusGrid from "../DashnoardComponents/DashboardStatusGrid/DashboardStatusGrid";

const AdminDashboard = () => {
    const { data, isLoading } = useContext(dashboardContext);
    const { width } = useScreenSize();
    return (
        <>
            <div className="dashboard-header">{isLoading ? <TextSkeleton width='15%' fontSize='3rem' /> : `Dashboard`}</div>
            <div className='dashboard-card-main-container'>

                {isLoading ? (
                    <>
                        <CustomSkelton
                            height={160}
                            width={width > 600 ? '33%' : '100%'}
                        />
                        <CustomSkelton
                            height={160}
                            width={width > 600 ? '33%' : '100%'}
                        />
                        <CustomSkelton
                            height={160}
                            width={width > 600 ? '33%' : '100%'}
                        />
                    </>
                ) : (
                    <>
                        <DashboardCard
                            color1="#9575CD"
                            color2="#A67DFF"
                            image={total_sites}
                            title={`Worksites`}
                            count={data?.WorksitesCount || `0`}
                            icon={<FaBuilding />}
                        />
                        <DashboardCard
                            color1="#1E88E5"
                            color2="#439DFE"
                            image={total_engineers}
                            title={`Active Users`}
                            count={data?.ActiveuserCount || `0`}
                            icon={<FaUsers />}
                        />
                        <DashboardCard
                            color1="#FFB74D"
                            color2="#FDB73B"
                            image={task_overview}
                            title={`Total Revenue`}
                            subTitle={`(in AED)`}
                            count={data?.totalRevanue || `0`}
                            icon={<BsGraphUpArrow />}
                        />
                    </>
                )}

            </div>
            <DashboardStatusGrid />
        </>
    );
};

export default AdminDashboard;